import React, { Fragment, useEffect, useState } from 'react'
import Humberg from '../../elements/Humberg';
import { useDispatch, useSelector } from 'react-redux';
import LoaderBlock from '../loader/LoaderBlock';
import SingleReservation from './SingleReservation';
import DateFilter from '../../elements/DateFilter';

import Filters from './Filters';
import Loader from '../loader/loader';
import { UPDATE_RESERVATION_STATUS_RESET } from '../../redux/constants/reservationConstants';
import { allReservationsAction, updateReservationStatusActions } from '../../redux/actions/reservationActions';


const Reservations = () => {



    const dispatch = useDispatch()


    const { loading,
        reservations,
        totalReservations,
        totalPages,
    } = useSelector((state) => state.reservations)

    const { user } = useSelector(state => state.verifyEmailStore);
    const { loading: reservationLoading, message } = useSelector((state) => state.reservation)





    const [page, setPage] = useState('1');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [selectedReservations, setSelectedReservations] = useState([]);



    useEffect(() => {
        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const subLinks = document.querySelectorAll(".subLinks");
        const element = document.getElementById("reservations")


        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        subLinks.forEach(el => el.classList.remove("activeSubLink"));
        element?.classList.add("activeHeaderLink");

        document.title = `Reservations `;

    }, []);
    // Remove one quantity



    useEffect(() => {
        if (message) {
            dispatch(allReservationsAction())
            dispatch({ type: UPDATE_RESERVATION_STATUS_RESET })
            setShowPopup(false)
        }
    }, [dispatch, message])

    const handleReserve = () => {
        if (selectedReservations.length > 0) {
            dispatch(updateReservationStatusActions({
                reservationIds: selectedReservations
            }));
            setSelectedReservations([]);
        }
    };


    return (
        <Fragment>
            {reservationLoading && <Loader />}
            <Humberg header="Dashboard" headerLink="/" children={"Reservations"} />
            <DateFilter
                dateFrom={dateFrom}
                setDateFrom={setDateFrom}
                dateTo={dateTo}
                setDateTo={setDateTo}
            />
            <section className="p-[1.5vmax] mt-[1vmax] " >


                <Filters page={page} setPage={setPage} dateFrom={dateFrom} dateTo={dateTo} />
                <div className="bg-white flex justify-between items-center  px-[2vmax] pt-[2vmax]">
                    <div className="flex-center">
                        <span className='flex-center' >Select All &nbsp;&nbsp;:&nbsp;&nbsp;</span>
                        <input
                            type="checkbox"
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedReservations(reservations.map(r => r.id));
                                } else {
                                    setSelectedReservations([]);
                                }
                            }}
                        />
                    </div>
                    {selectedReservations?.length > 0 && (

                        <button
                            className="bg-[image:var(--gradient-4)] text-white px-[1vmax] py-[0.5vmax] rounded-lg mb-[1vmax]  text-[1.5vmax] lg:text-[0.9vmax]"
                            onClick={() => setShowPopup(true)}
                        >
                            Cancel Selected ({selectedReservations.length})
                        </button>
                    )}

                </div>

                <div className="bg-white p-[2vmax] lg:mt-[-2vmax] shadow-1 rounded-b-lg overflow-x-auto my-scroll-2 my-scroll-3 pb-[15vmax]">

                    <div className="min-w-[1500px] mt-[2vmax] border border-gray-200 rounded-xl shadow-sm bg-white">
                        {/* Header */}
                        <div 
                            className="grid bg-gray-50 py-[1vmax] items-center border-b border-gray-200 rounded-t-xl"
                            style={{ gridTemplateColumns: user?.role !== 'PM' 
                                ? 'minmax(0, 0.7fr) minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1.5fr) minmax(0, 1.8fr) minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 2.5fr)' 
                                : 'minmax(0, 0.7fr) minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1.8fr) minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 2.5fr)' }}
                        >
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.8vmax] lg:text-[0.9vmax] font-bold" >
                                Select
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.8vmax] lg:text-[0.9vmax] font-bold" >
                                No.
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.8vmax] lg:text-[0.9vmax] font-bold" >
                                Product
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.8vmax] lg:text-[0.9vmax] font-bold" >
                                Seller
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.8vmax] lg:text-[0.9vmax] font-bold" >
                                Market
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.8vmax] lg:text-[0.9vmax] font-bold" >
                                Product ID
                            </div>
                            {user?.role !== 'PM' &&
                                <div className="text-center text-[#4c4c5c] uppercase text-[1.8vmax] lg:text-[0.9vmax] font-bold" >
                                    Reserved By
                                </div>
                            }
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.8vmax] lg:text-[0.9vmax] font-bold" >
                                Reserved On
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.8vmax] lg:text-[0.9vmax] font-bold" >
                                Expires In
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.8vmax] lg:text-[0.9vmax] font-bold" >
                                Status
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.8vmax] lg:text-[0.9vmax] font-bold" >
                                Action
                            </div>

                        </div>

                        {/* Rows */}
                        {loading ?
                            <LoaderBlock />
                            :
                            reservations?.length > 0 ?
                                reservations.map((reservation, index) =>
                                    <SingleReservation
                                        key={reservation.id}
                                        reservation={reservation}
                                        index={index}
                                        totalReservations={totalReservations}
                                        user={user}
                                        setShowPopup={setShowPopup}
                                        page={page}
                                        selectedReservations={selectedReservations}
                                        setSelectedReservations={setSelectedReservations}
                                    />)
                                :
                                <div className="text-center text-[1.5vmax] text-gray-400 py-[3vmax]" >
                                    No data found
                                </div>
                        }
                    </div>
                </div>
            </section>
            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[2vmax]">

                    {/* Prev button */}
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {/* --- SMART PAGINATION START --- */}
                    {(() => {
                        const pages = [];
                        const maxVisible = 3; // number of pages to show around current page

                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        // Always show First Page
                        addPage(1);

                        // Left dots
                        if (page > maxVisible + 2) {
                            pages.push(<span key="dots-left">...</span>);
                        }

                        // Middle pages (dynamic)
                        for (
                            let p = Math.max(2, page - maxVisible);
                            p <= Math.min(totalPages - 1, page + maxVisible);
                            p++
                        ) {
                            addPage(p);
                        }

                        // Right dots
                        if (page < totalPages - (maxVisible + 1)) {
                            pages.push(<span key="dots-right">...</span>);
                        }

                        // Always show Last Page
                        if (totalPages > 1) {
                            addPage(totalPages);
                        }

                        return pages;
                    })()}
                    {/* --- SMART PAGINATION END --- */}

                    {/* Next button */}
                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>
            )}
            {showPopup &&
                <section className="w-[100%] min-h-[100vh] flex-center fixed top-0 left-0 bg-[#000000b7] z-[99999999999]">
                    <button className="fixed top-[2vmax] right-[2vmax]"
                        onClick={() => setShowPopup(false)}
                    >
                        <i className="fa-solid fa-xmark text-white text-[2vmax]"></i>
                    </button>
                    <div className="bg-white rounded-xl  shadow-1 overflow-hidden w-[80%] lg:w-[35%]">
                        <div className="font-3 font-[700] text-white bg-[image:var(--gradient-2)] py-[0.6vmax] text-center text-[2vmax] lg:text-[1.5vmax]">
                            Cancel Reservation
                        </div>
                        <p className='p-[1.5vmax] text-[1.5vmax] lg:text-[1.1vmax] text-slate-700' >
                            Are you sure you want to cancel this reservation?
                        </p>
                        <div className="flex justify-end gap-[1.5vmax] p-[1.5vmax]">
                            <button className="text-[1.5vmax] lg:text-[1.1vmax] font-3 bg-gray-500 text-white 
                            p-[0.5vmax_1vmax] rounded-lg "
                                onClick={() => setShowPopup(false)}
                            >No</button>

                            <button className="text-[1.5vmax] lg:text-[1.1vmax] font-3 bg-[image:var(--gradient-2)] text-white 
                            p-[0.5vmax_1vmax] rounded-lg"
                                onClick={handleReserve}
                            >Yes</button>
                        </div>
                    </div>
                </section>

            }
            <br />
            <br />
            <br />
            <br />
        </Fragment>
    )
}

export default Reservations